import React, { useState, useEffect, useRef, useMemo } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import Button from "components/CustomButtons/Button.js";
import defaultImage from "assets/img/image_placeholder.jpg";
import defaultAvatar from "assets/img/placeholder.jpg";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: '#fff',
    display: "flex",
  },
  input: {
    display: "flex",
    flexDirection: "column",
    margin: "1rem 0rem 0rem",
  },
  inputTitle: {
    margin: "0.2rem 0rem 0.05rem 0.5rem",
  },
}));

export default function PictureInput(props) {
  const { inputTitle, file, setFile } = props;

  const classes = useStyles();

  function ImageUpload(props) {
    const [imagePreviewUrl, setImagePreviewUrl] = useState(
      props.avatar ? defaultAvatar : defaultImage
    );
    let fileInput = React.createRef();
    const handleImageChange = (e) => {
      e.preventDefault();
      let reader = new FileReader();
      let file = e.target.files[0];
      reader.onloadend = () => {
        setFile(file);
        setImagePreviewUrl(reader.result);
      };
      if (file) {
        reader.readAsDataURL(file);
      }
    };
    // eslint-disable-next-line
    const handleSubmit = (e) => {
      e.preventDefault();
      // file is the file/image uploaded
      // in this function you can save the image (file) on form submit
      // you have to call it yourself
    };
    const handleClick = () => {
      fileInput.current.click();
    };
    const handleRemove = () => {
      setFile(null);
      setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
      fileInput.current.value = null;
    };
    let {
      avatar,
      addButtonProps,
      changeButtonProps,
      removeButtonProps,
    } = props;
    return (
      <div className="fileinput text-center">
        <input type="file" onChange={handleImageChange} ref={fileInput} />
        <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
          <img src={imagePreviewUrl} alt="..." />
        </div>
        <div>
          {file === null ? (
            <Button {...addButtonProps} onClick={() => handleClick()}>
              {avatar ? "Add Photo" : "Select image"}
            </Button>
          ) : (
            <span>
              <Button {...changeButtonProps} onClick={() => handleClick()}>
                Change
              </Button>
              {avatar ? <br /> : null}
              <Button {...removeButtonProps} onClick={() => handleRemove()}>
                <i className="fas fa-times" /> Remove
              </Button>
            </span>
          )}
        </div>
      </div>
    );
  }
  ImageUpload.propTypes = {
    avatar: PropTypes.bool,
    addButtonProps: PropTypes.object,
    changeButtonProps: PropTypes.object,
    removeButtonProps: PropTypes.object,
  };

  return (
    <div className={classes.input}>
      <text className={classes.inputTitle}>{inputTitle}</text>
      <ImageUpload />
    </div>
  );
}
